import { render, staticRenderFns } from "./BankAccountCard.vue?vue&type=template&id=85977514&scoped=true&"
import script from "./BankAccountCard.vue?vue&type=script&lang=js&"
export * from "./BankAccountCard.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountCard.vue?vue&type=style&index=0&id=85977514&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85977514",
  null
  
)

export default component.exports